const DEFAULT_HEADER = {
    showLogo: true,
    logoPosition: 'left',
    logoPositionMobile: 'center',
    logoHeight: '60px',
    logoHeightMobile: '40px',
    showClinicName: true,
    padding: { top: '1rem', bottom: '1rem' },
};

export const getClinicLogoUrl = (clinicContent) => {
    if (!clinicContent?.logo) {
        return null;
    }

    const url = typeof clinicContent.logo === 'string'
        ? clinicContent.logo
        : clinicContent.logo.url;

    return url && url !== '<<CLINIC_LOGO>>' ? url : null;
};

export const getClinicLogoAlt = (clinicContent) => {
    if (typeof clinicContent?.logo === 'object' && clinicContent.logo?.alt) {
        return clinicContent.logo.alt;
    }

    return clinicContent?.name ? `${clinicContent.name} Logo` : 'Clinic Logo';
};

export const mergeThemeContent = (themeContent) => {
    if (!themeContent) {
        return null;
    }

    return {
        ...themeContent,
        header: {
            ...DEFAULT_HEADER,
            ...(themeContent.header || {}),
            padding: {
                ...DEFAULT_HEADER.padding,
                ...(themeContent.header?.padding || {}),
            },
        },
    };
};

export const buildPreviewTheme = (themeContent, clinicContent) => {
    const mergedTheme = mergeThemeContent(themeContent);
    if (!mergedTheme) {
        return null;
    }

    const clinicInfo = clinicContent || {};
    const mergedClinicInfo = {
        name: clinicInfo.name || '',
        tagline: clinicInfo.tagline || '',
        address: clinicInfo.address || {},
        contact: clinicInfo.contact || {},
        socialMedia: clinicInfo.socialMedia || [],
        hours: clinicInfo.hours || [],
    };

    return {
        ...mergedTheme,
        clinicInfo: mergedClinicInfo,
    };
};
